/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Announcement } from '../../models/announcement';
import { KeyType } from '../../models/key-type';

export interface GetServiceProviderAnnouncement$Params {

/**
 * The announcement key
 */
  announcementKey: KeyType;
}

export function getServiceProviderAnnouncement(http: HttpClient, rootUrl: string, params: GetServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
  const rb = new RequestBuilder(rootUrl, getServiceProviderAnnouncement.PATH, 'get');
  if (params) {
    rb.path('announcementKey', params.announcementKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Announcement>;
    })
  );
}

getServiceProviderAnnouncement.PATH = '/service-provider/announcements/{announcementKey}';
